import { useEffect, useState } from 'react'

// 画像URLからImageオブジェクトを返す
export function useImage(src: string) {
  const [image, setImage] = useState<HTMLImageElement | null>(null)

  useEffect(() => {
    if (!src) return
    const img = new Image()
    img.src = src

    const handleOnload = () => {
      setImage(img)
    }
    img.addEventListener('load', handleOnload)
    return () => {
      img.removeEventListener('load', handleOnload)
    }
  }, [src])

  return image
}
